// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xfjR5YAltUuJ6KbeELA7{display:flex;flex-direction:column;gap:15px}.DGOfM0m8G59XccBC3sYE{padding:16px 0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/integrationSettings/IntegrationActiveCampaignSettings/ui/IntegrationActiveCampaignSettingsSync/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAEF,sBACE,cAAA","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.titledRow {\n  padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `xfjR5YAltUuJ6KbeELA7`,
	"titledRow": `DGOfM0m8G59XccBC3sYE`
};
export default ___CSS_LOADER_EXPORT___;
